module.exports = __webpack_public_path__ + "img/logo.23d12acb.svg";